module.exports = __webpack_public_path__ + "assets/images/RedShade.1ca359acc1658962016d50fe0fb340aa.png";